import * as types from '../types.js';
// import {apiBookInit,apiNewPage,apiSaveBooks} from '@/request/api.js';
const state = {
	//书本基本信息
	// bookInfo:null,
	// //书本内页数组
	// bookList:null,
	// //类型信息
	// typeInfo:null,
	// //该书的闲置照片数组
	// leaveImages:null,
	// //1等待保存2保存中3已保存
	// keepBooks:3
};
const getters = {
	// // 获取书本信息
	// [types.GET_BOOKINFO]:(state,getters)=>{
	// 	return state.bookInfo;
	// },
	// // 获取书本内页数组
	// [types.GET_BOOKLIST]:(state,getters)=>{
	// 	return state.bookList;
	// },
	// // 获取类型信息
	// [types.GET_TYPEINFO]:(state,getters)=>{
	// 	return state.typeInfo;
	// },
	// // 获取该书的闲置照片数组
	// [types.GET_LEAVEIMAGES]:(state,getters)=>{
	// 	return state.leaveImages.filter(item=>{
	// 		return item.is_del!==1;
	// 	});
	// },
	// // 获取该书的闲置照片数组
	// [types.GET_LEAVEIMAGES_ALL]:(state)=>{
	// 	return state.leaveImages;
	// },
	// // 获取保存状态
	// [types.GET_KEEPBOOKES]:(state)=>{
	// 	return state.keepBooks;
	// }
};
const mutations = {
	//修改书本的名称
	// [types.SET_BOOK_NAME]:(state,val)=>{
	// 	state.bookInfo.title = val;
	// },
	// //书本的保存状态
	// [types.SET_BOOK_UPDATE]:(state,val)=>{
	// 	state.bookInfo.savetime = Date.parse(new Date()) / 1000;
	// 	state.keepBooks = val;
	// },
	// //初始化书本变量
	// [types.MAKE_INIT_EMPTY]:(state,val)=>{
	// 	console.log(val);
	// 	//书本基本信息
	// 	state.bookInfo = null;
	// 	//书本内页数组
	// 	state.bookList = null;
	// 	//类型信息
	// 	state.typeInfo = null;
	// 	//该书的闲置照片数组
	// 	state.leaveImages = null;
	// 	//1等待保存2保存中3已保存
	// 	state.keepBooks = 3;
	// },
	// // 设置书本基本信息
	// [types.SET_BOOKINFO]:(state,val)=>{
	// 	state.bookInfo = val;
	// },
	// // 设置书本内页数组
	// [types.SET_BOOKLIST]:(state,val)=>{
	// 	state.bookList = val;
	// },
	// // 设置类型信息
	// [types.SET_TYPEINFO]:(state,val)=>{
	// 	state.typeInfo = val;
	// },
	// // 设置该书的闲置照片数组
	// [types.SET_LEAVEIMAGES]:(state,val)=>{
	// 	state.leaveImages = val;
	// },
	// // 修改文字数据
	// [types.SET_PAGE_TEXT]:(state,params)=>{
	// 	const page = state.bookList.find(item=>{
	// 		return item.id === params.id
	// 	});
	// 	page.data[params.field] = params.content;
	// },
	// // 修改图片数据
	// [types.SET_PAGE_IMAGE]:(state,params)=>{
	// 	const page = state.bookList.find(item=>{
	// 		return item.id === params.id
	// 	});
	// 	page.data[params.field] = params.data;
	// },
	// //替换闲置图片
	// [types.SET_UNINSTALL_IMAGES]:(state,ob)=>{
	// 	// 如果从闲置队列中取出
	// 	if(ob.remove){
	// 		const record = state.leaveImages.find(item=>{
	// 			return item.path === ob.remove;
	// 		});
	// 		state.leaveImages.splice(state.leaveImages.indexOf(record),1);
	// 	}
	// 	//如果加入从闲置队列
	// 	if(ob.join){
	// 		// 如果是预定义的图片那么不加入闲置图片队列 (预定义图片包含 '/default/' 字符)
	// 		if(ob.join.search(/\/default\//) === -1){
	// 			//分解图片 追加入 闲置队列
	// 			// const path = ob.join.replace(/^http:\/\/[^/]+/,'');
	// 			const path = ob.join.replace(/^http:\/\/[^/]+\//,'');
	// 			//加入新的
	// 			state.leaveImages.unshift({
	// 				is_del:0,
	// 				path: path.replace(/@\s*([\w\W]*?)\s*\./, '.'),
	// 				save_time:Date.parse(new Date())/1000,
	// 				size:ob.size
	// 			});
	// 		}
	// 	}
	// },
	// // 将二维码加入队列
	// [types.SET_UNINSTALL_QRCODE_IMAGES]:(state,ob)=>{
	// 	if(ob.join){
	// 		// 如果是预定义的图片那么不加入闲置图片队列 (预定义图片包含 '/default/' 字符)
	// 		if(ob.join.search(/\/default\//) === -1){
	// 			//加入新的
	// 			state.leaveImages.unshift({
	// 				is_del:1,
	// 				path: ob.join.replace(/^http:\/\/[^/]+/,''),
	// 				save_time:Date.parse(new Date())/1000,
	// 				size:ob.size
	// 			});
	// 		}
	// 	}
	// },
	// //删除闲置图片
	// [types.DEL_LEAVE_IMAGE]:(state,path)=>{
	// 	const record = state.leaveImages.find(item=>{
	// 		return item.path === path;
	// 	});
	// 	const index = state.leaveImages.indexOf(record)
	// 	record.is_del = 1;
	// 	state.leaveImages.splice(index,1,record);
	// },
	// //执行修改版面样式
	// [types.SET_NEW_MODULE]:(state,ob)=>{
	// 	// page_id页码id   ,   new_page新的模板
	// 	const respo = state.bookList.find(item => {
	// 		return item.id === ob.page_id;
	// 	});
	// 	// 防止模型相同
	// 	if(respo.module_id!==ob.new_page.module_id){
	// 		//拼接新页面的数据集合
	// 		const newPage = ob.new_page;
	// 		const data = {
	// 			book_id:newPage.book_id,
	// 			componentStr:newPage.componentStr,
	// 			data:newPage.data,
	// 			id:respo.id, // 服务器保存的时候需要重新处理
	// 			module_center:newPage.module_center,
	// 			module_head:newPage.module_head,
	// 			module_id:newPage.module_id,
	// 			module_tail:newPage.module_tail,
	// 			module_validata:newPage.module_validata,
	// 			mold:newPage.mold,
	// 			size:newPage.size,
	// 			onlySize:newPage.onlySize,
	// 			sort:newPage.sort, // 服务器保存的时候需要重新处理
	// 			typeName:newPage.typeName
	// 		};
	// 		//摘下使用中的图片到闲置图片里
	// 		const imgArr = respo.data;
	// 		Object.keys(imgArr).forEach(function(key){
	// 			//如果有路径则将图片取下
	// 			if(imgArr[key]['path']){
	// 				let imgPath = imgArr[key]['path'];
	// 				//如果是预定义图片则不加入闲置队列
	// 				if(imgPath.search(/\/default\//) === -1){
	// 					//获得图片压入闲置图片队列
	// 					state.leaveImages.unshift({
	// 						is_del:0,
	// 						path: imgPath.replace(/@\s*([\w\W]*?)\s*\./, '@default.'), // 压入原生default图片
	// 						save_time:Date.parse(new Date())/1000,
	// 						size:imgArr[key]['size']
	// 					});
	// 				}
	// 			}
	// 	    })
	// 	    //获取旧的index位置
	// 		const index = state.bookList.indexOf(respo);
	// 		//执行替换面板操作
	// 		state.bookList.splice(index, 1, data);
	// 	}else{}
	// },
	// //执行向上移动
	// [types.MAKE_PAGE_UP]:(state,ob) => {
	// 	var runArr = [state.bookList[ob.index],state.bookList[ob.index-1]];
	// 	state.bookList.splice(ob.index-1,2,...runArr);
	// 	setTimeout(function(){
	// 		(ob.fun)();
	// 	},1);
	// },
	// //执行向下移动
	// [types.MAKE_PAGE_DOWN]:(state,ob) => {
	// 	var runArr = [state.bookList[ob.index+1],state.bookList[ob.index]];
	// 	state.bookList.splice(ob.index,2,...runArr);
	// 	setTimeout(function(){
	// 		(ob.fun)();
	// 	},1);
	// },
	// //删除页面
	// [types.MAKE_PAGE_DEL]:(state,pageID) => {
	// 	//查询该页
	// 	// 通过pageid获取对应的元素
	// 	let record = state.bookList.find(item=>{
	// 		return item.id == pageID;
	// 	});
	// 	// 筛查出图片加入闲置图片队列
	// 	const data = record.data;

	// 	// console.log(record);

	// 	if(data){
	// 		Object.keys(data).forEach(function(key){
	// 			//判断是否为路径
	// 			if(data[key]['path']){
	// 				let imgPath = data[key]['path'];
	// 				//如果是预定义图片则不加入闲置队列 如果是二维码则为删除状态
	// 				if(imgPath.search(/@qrcode\./)!=-1){
	// 					//如果是二维码
	// 					state.leaveImages.unshift({
	// 						is_del:1,
	// 						path: imgPath,
	// 						save_time:Date.parse(new Date())/1000,
	// 						size:data[key]['size']
	// 					});
	// 				}else if(imgPath.search(/\/default\//) == -1){
	// 					//如果不是系统图
	// 					state.leaveImages.unshift({
	// 						is_del:0,
	// 						path: imgPath.replace(/@\s*([\w\W]*?)\s*\./, '.'),
	// 						save_time:Date.parse(new Date())/1000,
	// 						size:data[key]['size']
	// 					});
	// 				}else{

	// 				}
	// 			}
	// 	    })
	// 	}
	// 	//执行删除操作
	// 	const index = state.bookList.indexOf(record);
	// 	state.bookList.splice(index,1);
	// },
	// //执行添加新的页面
	// [types.MAKE_PAGE_JOIN]:(state,ob) => {
	// 	// 获取坐标
	// 	const infoOb = state.bookList.find(item=>{
	// 		return item.id == ob.info.id
	// 	});
	// 	const index = state.bookList.indexOf(infoOb);
	// 	//执行添加
	// 	state.bookList.splice(index+1, 0, ob.data);
	// },
	// //将限制图片内的删除状态图片剔除
	// [types.SAVE_LEAVE_DATA]:(state) => {
	// 	state.leaveImages = state.leaveImages.filter(item=>{
	// 		return item.is_del!==1;
	// 	});
	// }
};
const actions = {
	// 获取本书的信息
	// [types.MAKE_INIT]:({commit,state},bookId)=>{
	// 	return apiBookInit({str:bookId}).then(ob=>{
	// 		if(ob.state==1){
	// 			// 设置书本基本信息
	// 			commit(types.SET_BOOKINFO,ob.data.bookInfo);
	// 			// 处理内页的数据
	// 			ob.data.bookList.map(item=>{
	// 				item.componentStr = [item.module_head, item.module_center, item.module_tail].filter(item=>item).join('-'); //拼接组件名
	// 				return item;
	// 			});
	// 			// 设置内页
	// 			commit(types.SET_BOOKLIST,ob.data.bookList);
	// 			// 类型基本信息
	// 			commit(types.SET_TYPEINFO,ob.data.typeInfo);
	// 			// 闲置图片
	// 			commit(types.SET_LEAVEIMAGES,ob.data.leaveImages);
	// 			return ob;
	// 		}else{
	// 			return ob;
	// 		}
	// 	}).catch(ob=>{
	// 		return {state:4,message:'请求失败',data:[]};
	// 	});
	// },
	// //执行数据保存云端
	// [types.SAVE_BOOK_DATA]:({commit,state})=>{
	// 	return apiSaveBooks({str:state.bookInfo.str,bookInfo:state.bookInfo,bookList:state.bookList,leaveImages:state.leaveImages}).then(ob=>{
	// 		if(ob.state==2){
	// 			return ob;
	// 		}else{
	// 			return {state:4,message:'保存失败',data:[]};
	// 		}
	// 	}).catch(ob=>{
	// 		return {state:4,message:'保存失败',data:[]};
	// 	});
	// },
	// //远程随机获取素材
	// /**
	//  * *
	//  * @param  ob.mold 页面类型
	//  * @param  ob.module_id 版面模型
	//  * @param  ob.book_id 所属书本id
	//  */
	// [types.MAKE_PAGE_ADD]:({commit,state},ob)=>{
	// 	/**
	// 	 * modl:1,2,3,4,4,5
	// 	 * 1无法添加
	// 	 * 2无法添加
	// 	 * 3同module_id
	// 	 * 4同module_id
	// 	 * 5无法添加
	// 	 * 6无法添加
	// 	 */
	// 	return apiNewPage({mold:ob.mold,module_id:ob.module_id,book_id:ob.book_id}).then(respo=>{
	// 		if(respo.state==2){
	// 			commit(types.MAKE_PAGE_JOIN,{info:ob,data:respo.data});
	// 			return {state:respo.state,message:respo.message,data:{id:respo.data.id}};
	// 		}
	// 		return {state:respo.state,message:respo.message,data:{}};
	// 	}).catch(respo=>{
	// 		return {state:4,message:'请求失败',data:[]};
	// 	});
	// }
};
//抛出
export default {state,getters,mutations,actions};


// WEBPACK FOOTER //
// ./src/store/modules/make.js